import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type DashboardSolidIconProps = IconProps;

export const DashboardSolidIcon = forwardRef<
  SVGSVGElement,
  DashboardSolidIconProps
>(function DashboardSolidIcon(props: DashboardSolidIconProps, ref) {
  return (
    <Icon
      data-testid="DashboardSolidIcon"
      aria-label="dashboard solid"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path d="M6 7.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5z" />
      <path d="M11.197 10H.802a6 6 0 1 1 10.394 0zM5.5 2.025v1.511a3.578 3.578 0 0 1 1 0V2.025a5.15 5.15 0 0 0-1 0zM2.362 3.57l1.061 1.061c.227-.247.49-.461.779-.635L3.119 2.913a4.992 4.992 0 0 0-.757.657zM2.5 7c0-.347.051-.683.145-1H1.1c-.066.323-.1.658-.1 1h1.5zm8.4-1H9.355c.094.317.145.653.145 1H11c0-.342-.034-.677-.1-1zm-3.4.5c0-.187-.034-.365-.096-.53l1.589-1.589-.707-.707-1.53 1.53A1.5 1.5 0 1 0 7.5 6.5z" />
    </Icon>
  );
});
